import { useRouter } from 'expo-router'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from '@/src/elements/button/default'
import type { TFavoritePublicationApi } from '@/src/features/publication/api/types/publicationApi.types'
import { PublicationCard } from '@/src/features/publication/ui/components/PublicationCard'
import { PublicationSeed } from '@/src/features/publication/ui/components/PublicationSeed/PublicationSeed'
import { ICON } from '@/src/general/enums/icons'
import { PUBLICATION_TRACKING_SOURCE, TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { useRoutes } from '@/src/general/utils/routes'

import { SettingsSectionTitle } from './SettingsSectionTitle'

type TFavoritesSectionProps = {
  favorites?: TFavoritePublicationApi[]
}

export const FavoritesSection = ({ favorites }: TFavoritesSectionProps): ReactNode => {
  const router = useRouter()
  const { routes } = useRoutes()

  const validFavorites = (favorites ?? []).filter((f) => !!f.publication)
  const hasFavorites = validFavorites.length > 0
  if (!hasFavorites) return null

  const displayedFavorites = validFavorites.slice(0, 2)
  const hasMoreFavorites = validFavorites.length > 2

  return (
    <>
      <SettingsSectionTitle>
        <FormattedMessage id="user.profile.favorite-publications" />
      </SettingsSectionTitle>
      {displayedFavorites.map((item) => (
        <PublicationSeed key={item.id} initialPublicationId={item.publication.id}>
          {({ data: publicationSeed }) => (
            <PublicationCard
              publication={{
                ...(publicationSeed ?? item.publication),
                hasPrayed: false,
                community: {
                  ...item.publication.community,
                  isAdmin: false,
                  isAnimator: false,
                  isCreator: false,
                  hasJoined: false,
                },
              }}
              trackingSource={TRACKING_SOURCE.PROFILE_PAGE}
              publicationTrackingSource={PUBLICATION_TRACKING_SOURCE.PROFILE}
            />
          )}
        </PublicationSeed>
      ))}
      {hasMoreFavorites && (
        <Button
          onPress={() => router.navigate(routes.favorites())}
          variant="faded"
          colors="default"
          size="sm"
          endIcon={ICON.CHEVRON_RIGHT}
          className="self-end web:self-end"
        >
          <FormattedMessage id="words.see-all.sing" />
        </Button>
      )}
    </>
  )
}
